// extracted by mini-css-extract-plugin
export default {"header":"VC","discountBanner":"WC","logo":"XC","maincontainer":"YC","videocontainer":"ZC","videowelcome":"aE","videowrapper":"bE","videosale":"cE","loadingcontainer":"eE","footer":"fE","footerbutton":"gE","video":"hE","logoname":"iE"};
    if(module.hot) {
      // 1715188236271
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  